import React, { useRef } from "react";

const Home = () => {
  const heroRef = useRef(null);

  return (
    <div
      style={{
        background: "#080808",
        color: "#fff",
        fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
        minHeight: "100vh",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap');

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        @keyframes pulse-red {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(239,68,68,0.4);
          }
          50% {
            box-shadow: 0 0 0 10px rgba(239,68,68,0);
          }
        }

        .btn-primary {
          animation: pulse-red 2.5s infinite;
        }

        .service-card {
          background: #111;
          border: 1px solid #1f1f1f;
          border-radius: 4px;
          padding: 2rem 1.5rem;
          transition: border-color 0.3s, transform 0.3s;
        }

        .service-card:hover {
          border-color: #ef4444;
          transform: translateY(-4px);
        }

        .service-icon {
          width: 48px;
          height: 4px;
          background: #ef4444;
          margin-bottom: 1.25rem;
        }

        .container {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding-left: 24px;
          padding-right: 24px;
        }

        .hero-content {
          position: relative;
          z-index: 10;
          max-width: 700px;
          padding: 0 24px;
        }

        .hero-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .video-content {
          position: absolute;
          left: 2.5rem;
          top: 50%;
          transform: translateY(-50%);
          max-width: 500px;
          z-index: 2;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: start;
        }

        .map-container {
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #1f1f1f;
          height: 420px;
        }

        @media (max-width: 992px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }

          .map-container {
            height: 350px;
          }
        }

        @media (max-width: 768px) {

          .container {
            padding-left: 18px;
            padding-right: 18px;
          }

          .hero-content {
            padding: 0 18px;
            text-align: center;
            max-width: 100%;
          }

          .hero-buttons {
            flex-direction: column;
            align-items: stretch;
          }

          .hero-buttons a {
            width: 100%;
            text-align: center;
          }

          .video-content {
            left: 18px;
            right: 18px;
            max-width: unset;
          }

          .service-card {
            padding: 1.5rem 1.2rem;
          }

          .map-container {
            height: 300px;
          }

          .footer-logo {
            height: 50px !important;
          }
        }

        @media (max-width: 480px) {

          .hero-logo {
            height: 60px !important;
          }

          .video-section {
            height: 500px !important;
          }

          .mobile-heading {
            line-height: 1.05 !important;
          }

          .mobile-text {
            font-size: 0.92rem !important;
          }

          .mobile-button {
            padding: 13px 20px !important;
            font-size: 0.9rem !important;
          }

          .contact-card {
            padding: 0.9rem 1rem !important;
          }

          .map-container {
            height: 260px;
          }
        }
      `}</style>

      {/* HERO */}
      <section
        ref={heroRef}
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          backgroundImage:
            "url('https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741281870/pro_nutritions_abanhk.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(135deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.7) 50%, rgba(150,20,20,0.3) 100%)",
          }}
        />

        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "#ef4444",
          }}
        />

        <div className="hero-content">
          <div style={{ marginBottom: "2rem" }}>
            <img
              src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741282821/Pro_Nutrition-01-removebg-preview_thyf18.png"
              alt="Pro Nutrition"
              className="hero-logo"
              style={{
                height: "80px",
                objectFit: "contain",
              }}
            />
          </div>

          <div
            style={{
              display: "inline-block",
              background: "#ef4444",
              color: "#fff",
              fontSize: "0.75rem",
              fontWeight: 700,
              letterSpacing: "0.2em",
              padding: "4px 16px",
              borderRadius: "2px",
              marginBottom: "1.5rem",
              textTransform: "uppercase",
              fontFamily: "'Barlow', sans-serif",
            }}
          >
            Sri Lanka's #1 Supplement Store
          </div>

          <h1
            className="mobile-heading"
            style={{
              fontSize: "clamp(3rem, 8vw, 6.5rem)",
              fontWeight: 900,
              lineHeight: 0.95,
              letterSpacing: "-0.02em",
              textTransform: "uppercase",
              marginBottom: "1.5rem",
            }}
          >
            POWER UP
            <br />
            <span
              style={{
                color: "#ef4444",
              }}
            >
              YOUR BODY
            </span>
          </h1>

          <p
            className="mobile-text"
            style={{
              fontSize: "1rem",
              color: "#d1d5db",
              maxWidth: "440px",
              lineHeight: 1.7,
              marginBottom: "2.5rem",
              fontFamily: "'Barlow', sans-serif",
              fontWeight: 400,
            }}
          >
            Authentic, high-performance supplements delivered to your door.
            Fuel every rep, every set, every goal.
          </p>

          <div className="hero-buttons">
            <a
              href="/shop"
              className="btn-primary mobile-button"
              style={{
                background: "#ef4444",
                color: "#fff",
                textDecoration: "none",
                padding: "14px 36px",
                borderRadius: "4px",
                fontWeight: 800,
                fontSize: "1rem",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                display: "inline-block",
              }}
            >
              Shop Now
            </a>

            <a
              href="/shop"
              className="mobile-button"
              style={{
                border: "1.5px solid rgba(255,255,255,0.4)",
                color: "#fff",
                textDecoration: "none",
                padding: "14px 36px",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "1rem",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                display: "inline-block",
              }}
            >
              Explore Products →
            </a>
          </div>
        </div>
      </section>

      {/* VIDEO SECTION */}
      <section
        className="video-section"
        style={{
          position: "relative",
          height: "420px",
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source
            src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1741417764/Pro_Nutrition_Video_gogxnr.mp4"
            type="video/mp4"
          />
        </video>

        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to right, rgba(0,0,0,0.85) 40%, rgba(0,0,0,0.4) 100%)",
          }}
        />

        <div className="video-content">
          <div
            style={{
              width: "50px",
              height: "4px",
              background: "#ef4444",
              marginBottom: "1.5rem",
            }}
          />

          <h2
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: 900,
              textTransform: "uppercase",
              lineHeight: 1.1,
              marginBottom: "1rem",
            }}
          >
            The Science of
            <br />
            <span style={{ color: "#ef4444" }}>Nutrition</span>
          </h2>

          <p
            className="mobile-text"
            style={{
              color: "#d1d5db",
              fontFamily: "'Barlow', sans-serif",
              fontSize: "0.95rem",
              lineHeight: 1.7,
              marginBottom: "2rem",
            }}
          >
            Expertly formulated products that deliver real results.
            Backed by science, trusted by athletes.
          </p>

          <a
            href="/shop"
            className="mobile-button"
            style={{
              display: "inline-block",
              background: "#ef4444",
              color: "#fff",
              textDecoration: "none",
              padding: "12px 30px",
              borderRadius: "4px",
              fontWeight: 800,
              fontSize: "0.85rem",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            Discover Products
          </a>
        </div>
      </section>

      {/* CONTACT */}
      <section
        style={{
          background: "#0d0d0d",
          borderTop: "1px solid #1f1f1f",
          padding: "5rem 0",
        }}
      >
        <div className="container">
          <div style={{ marginBottom: "3rem" }}>
            <div
              style={{
                width: "50px",
                height: "4px",
                background: "#ef4444",
                marginBottom: "1.25rem",
              }}
            />

            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: 900,
                textTransform: "uppercase",
                marginBottom: "0.5rem",
              }}
            >
              Find Us
            </h2>

            <p
              style={{
                color: "#6b7280",
                fontFamily: "'Barlow', sans-serif",
              }}
            >
              Visit our store or reach out — we're always happy to help.
            </p>
          </div>

          <div className="contact-grid">
            <div>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "12px",
                  background: "#111",
                  border: "1px solid #1f1f1f",
                  borderRadius: "4px",
                  padding: "1rem 1.5rem",
                  marginBottom: "2rem",
                }}
              >
                <img
                  src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741282821/Pro_Nutrition-01-removebg-preview_thyf18.png"
                  alt="Pro Nutrition Logo"
                  style={{
                    height: "48px",
                    objectFit: "contain",
                  }}
                />

                <span
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 900,
                    letterSpacing: "0.1em",
                  }}
                >
                  PRO <span style={{ color: "#ef4444" }}>NUTRITION</span>
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.25rem",
                }}
              >
                {[
                  {
                    label: "Address",
                    value: "417, 1 Galle Rd, Moratuwa 10400, Sri Lanka",
                  },
                  {
                    label: "Phone / WhatsApp",
                    value: "+94 76 579 4062",
                  },
                  {
                    label: "Hours",
                    value: "Open 7 days a week",
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    className="contact-card"
                    style={{
                      padding: "1rem 1.25rem",
                      background: "#111",
                      border: "1px solid #1f1f1f",
                      borderRadius: "4px",
                    }}
                  >
                    <p
                      style={{
                        color: "#4b5563",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        letterSpacing: "0.18em",
                        textTransform: "uppercase",
                        fontFamily: "'Barlow', sans-serif",
                        marginBottom: "0.35rem",
                      }}
                    >
                      {item.label}
                    </p>

                    <p
                      style={{
                        color: "#d1d5db",
                        fontFamily: "'Barlow', sans-serif",
                        lineHeight: 1.6,
                      }}
                    >
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.8459852823157!2d79.88253907570576!3d6.7885886200245675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2450010637be1%3A0x515feb060d69cf7b!2sPro%20Nutrition!5e0!3m2!1sen!2slk!4v1779540818301!5m2!1sen!2slk"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Pro Nutrition Location"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <section
        style={{
          background: "#0f0f0f",
          borderTop: "1px solid #1f1f1f",
          padding: "4rem 1.5rem",
          textAlign: "center",
        }}
      >
        <img
          src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741282821/Pro_Nutrition-01-removebg-preview_thyf18.png"
          alt="Pro Nutrition"
          className="footer-logo"
          style={{
            height: "60px",
            objectFit: "contain",
            marginBottom: "1.5rem",
            opacity: 0.9,
          }}
        />

        <h3
          style={{
            fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
            fontWeight: 900,
            textTransform: "uppercase",
            marginBottom: "0.75rem",
          }}
        >
          Ready to Level Up?
        </h3>

        <p
          style={{
            color: "#6b7280",
            fontFamily: "'Barlow', sans-serif",
            fontSize: "0.95rem",
            marginBottom: "2rem",
          }}
        >
          Contact us on WhatsApp for orders and inquiries.
        </p>

        <a
          href="https://api.whatsapp.com/send?phone=+94765794062"
          target="_blank"
          rel="noreferrer"
          className="mobile-button"
          style={{
            display: "inline-block",
            background: "#ef4444",
            color: "#fff",
            textDecoration: "none",
            padding: "14px 40px",
            borderRadius: "4px",
            fontWeight: 800,
            fontSize: "1rem",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          Chat on WhatsApp
        </a>

        <p
          style={{
            marginTop: "3rem",
            color: "#374151",
            fontSize: "0.8rem",
            fontFamily: "'Barlow', sans-serif",
          }}
        >
          © {new Date().getFullYear()} Pro Nutrition Sri Lanka. All rights
          reserved.
        </p>
      </section>
    </div>
  );
};

export default Home;